import styled from "@emotion/styled";
import { FontSizeInPx, FontWeight, Spacing } from "@snapchat/snap-design-system";
import { Sizes } from "@snapchat/snap-design-system-icons";

export const LensDetailsPanelDisplay = styled.div`
    display: inline-flex;
    flex-direction: column;
    justify-content: center;

    svg {
        width: ${Sizes.Small}px;
        height: ${Sizes.Small}px;
        margin-right: ${Spacing["2XS"] + Spacing["3XS"]}px;
        margin-left: 1px;
    }
`;

export const LensDetailsPanelRow = styled.div`
    display: inline-flex;
    align-items: center;

    font-size: ${FontSizeInPx.COMPACT}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: 20px;
`;
